import React from "react";

const AboutPage = () => {
  return (
    <div>
      Icons made by{" "}
      <a
        href="https://www.flaticon.com/authors/vectors-market"
        title="Vectors Market"
      >
        Vectors Market
      </a>{" "}
      from{" "}
      <a href="https://www.flaticon.com/" title="Flaticon">
        www.flaticon.com
      </a>
    </div>
  );
};

export default AboutPage;
